import { ChangeDetectorRef, ViewRef } from '@angular/core';

export class ComponentChangeUtils {
  static detectChanges(changesDetector: ChangeDetectorRef): void {
    if (!(<ViewRef>changesDetector).destroyed) {
      changesDetector.detectChanges();
    }
  }
}
